import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRef } from 'react';
import parse from 'html-react-parser';

function UpdateEditor({ showMessage, id, setShowUpdate }) {

    const navigate = useNavigate();

    const [title, setTitle] = useState("");
    const [education, setEducation] = useState("");
    const [email, setEmail] = useState("");
    const [image, setImage] = useState("");
    const fileInputRef = useRef(null);

    const [editor, setEditor] = useState("");

    useEffect(() => {
    fetch(`https://annalsofnursing.org/aon_backend/api/api.php?action=getEditorById&id=${id}`)
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                setEditor(data.editor);

                setTitle(data.editor.title);
                setEducation(data.editor.education);
                setEmail(data.editor.email);
            } else {
                console.error(data.error);
            }
        });
    }, [id]);

    useEffect(() => {
            fetch('https://annalsofnursing.org/aon_backend/api/api.php?action=checkUserSession', {
                    method: 'GET',
                    credentials: "include",
                })
                .then(response => response.json())
                .then(data => {
                    if (data.success !== 'true') {
                        navigate("/dashboard/login")
                    }
                })
                .catch(error => {
                    console.log(error)
                });
    }, []);


    const updateEditor = async () => {
        
        const hasChanged = 
            title !== editor.title ||
            education !== editor.education ||
            email !== editor.email ||
            image;

        if (!hasChanged) {
            showMessage("info", "Nothing has changed.");
            return;
        }

        const formData = new FormData();
        formData.append('id', id);
        formData.append('title', title);
        formData.append('education', education);
        formData.append('email', email);
        if (image) {
            formData.append('image', image);
        }

        try {
            const response = await fetch(`https://annalsofnursing.org/aon_backend/api/api.php?action=updateEditor`, {
                method: 'POST',
                credentials: "include",
                body: formData,
            });

            const data = await response.json();
            if (data.success) {
                showMessage("success", "Editor updated successfully.");
                setTimeout(()=>{
                    window.location.reload()
                },1000)
            } else {
                showMessage("error", data.error || "Update failed.");
            }
        } catch (err) {
            console.error(err);
            showMessage("error", "An error occurred during update.");
        }
    };

    const cancelUpdateEditor = () => {
       setShowUpdate(false);
    }

    return (
      <>
                <div className='dash_update_records'>
                        <label>1. Title</label><br/>
                        <input className='dash_input' type="text" value={title} onChange={(e) => setTitle(e.target.value)} /><br/>

                        <label>2. Education</label><br/>
                        <input className='dash_input' type="text" value={education} onChange={(e) => setEducation(e.target.value)} /><br/>

                        <label>3. Email</label><br/>
                        <input className='dash_input' type="email" value={email} onChange={(e) => setEmail(e.target.value)} /><br/>

                        <label>4. Upload Image</label><br/>
                        <input ref={fileInputRef} className='dash_file_upload' type="file" onChange={(e) => setImage(e.target.files[0])} /><br/>

                        <br/><br/>
                        <div className='dash_buttons_wrapper'>
                            <button className='dash_form_buttom' onClick={()=>updateEditor()}>Update</button>
                            <button className='dash_form_buttom dash_reset' onClick={()=>cancelUpdateEditor()}>Cancel</button>
                        </div>
                        
                    </div>
                
      </>
    );
}

export default UpdateEditor;